import { render, staticRenderFns } from "./CustomModalComponent.vue?vue&type=template&id=48779878&scoped=true&"
import script from "./CustomModalComponent.vue?vue&type=script&lang=js&"
export * from "./CustomModalComponent.vue?vue&type=script&lang=js&"
import style0 from "./CustomModalComponent.vue?vue&type=style&index=0&id=48779878&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48779878",
  null
  
)

export default component.exports